import defaultForApi from './default-values';

function serializedForApi(draft, meta) {
    const { useId } = meta;

    const payload = {
        ...defaultForApi,
        ...draft,
    };

    if (useId) {
        // don't send email if editing
        delete payload.email;
    }

    return payload;
}

export default serializedForApi;
